module.exports = __webpack_public_path__ + "img/home-v2-6.3ed38233.jpg";